import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'

const LoadingWrapper = styled('div')`
  ${flexCenter}

  background-color: #FFFFFFE6;
  height: var(--content-view-height);
  left: 0;
  position: absolute;
  top: var(--nav-bar-height);
  z-index: 99;

  #case-level-navbar ~ #case-level-content & {
    height: calc(var(--content-view-height) - var(--case-nav-bar-height));
  }
`

const LoadingContainer = styled('div')`
  ${flexCenter}

  background-color: var(--london-fog);
  border-radius: 3px;
  border: 1px solid var(--gray-1);
  height: 70px;
  justify-content: flex-end;
  position: relative;
  width: 200px;

  > div {
    height: inherit;
    position: absolute;
    right: 40px;
    width: inherit;
    z-index: 0;
  }

  span {
    color: var(--print-secondary);
    margin-right: 49px;
    z-index: 3;
  }
`

export { LoadingContainer, LoadingWrapper }
